var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackLoopDonate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 630 675",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3698.54,-1664.14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0783,0,0,1.08781,3793.03,1716.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,522.236C-43.18,494.816 -81.695,453.117 -87.082,402.252C-89.131,382.892 -85.714,361.988 -72.987,347.258C-55.835,327.408 -27.206,323.602 -2.407,315.045C25.38,305.455 52.605,285.326 57.771,256.388C63.339,225.207 42.017,196.064 20.658,172.674C-0.701,149.284 -24.777,124.112 -26.437,92.48C-27.526,71.711 -18.391,51.608 -6.336,34.66C25.203,-9.684 77.2,-37.034 130.972,-45.379C184.744,-53.725 240.127,-44.396 291.395,-26.157C321.303,-15.517 350.373,-1.719 375.443,17.754C390.812,29.692 405.618,46.218 404.623,65.654C403.702,83.652 389.672,97.818 381.476,113.868C361.105,153.758 379.578,205.049 413.496,234.302C431.638,249.948 453.75,261.043 469.573,279.03C483.058,294.359 491.142,313.949 494.683,334.055C506.55,401.433 462.504,474.181 397.3,494.896C369.911,503.597 344.241,505.891 324.817,528.542C307.509,548.726 283.049,555.523 257.503,561.957C201.905,575.961 142.657,575.344 87.315,560.412C56.533,552.106 26.928,539.336 0,522.236",
    style: {
      fill: "rgb(240,239,255)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24202,0,0,0.24202,4250.73,2104.29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-12.179C-15.095,-11.667 -30.433,-13.732 -45.178,-10.463C-31.104,-3.926 -17.031,2.611 -2.958,9.149C3.571,12.181 11.163,15.238 17.699,12.219C22.647,9.933 25.503,4.775 28.025,-0.057C31.294,-6.318 34.604,-12.558 37.832,-18.839C42.241,-27.417 36.187,-23.288 31.805,-20.5C22.65,-14.674 10.765,-12.179 0,-12.179",
    style: {
      fill: "rgb(40,54,85)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24202,0,0,0.24202,4229.38,2063.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-43.525C7.974,-64.066 28.284,-79.239 50.243,-81.058C72.202,-82.878 94.732,-71.254 105.977,-52.304C117.222,-33.355 116.629,-8.01 104.511,10.392C92.392,28.795 69.343,39.353 47.493,36.508C10.688,31.718 -13.493,-8.762 0,-43.525",
    style: {
      fill: "rgb(108,99,255)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24202,0,0,0.24202,4229.38,2063.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-43.525C7.974,-64.066 28.284,-79.239 50.243,-81.058C72.202,-82.878 94.732,-71.254 105.977,-52.304C117.222,-33.355 116.629,-8.01 104.511,10.392C92.392,28.795 69.343,39.353 47.493,36.508C10.688,31.718 -13.493,-8.762 0,-43.525Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24202,0,0,0.24202,4197.79,2071.17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,119.465C1.912,95.451 3.846,71.309 9.681,47.937C15.515,24.565 25.492,1.784 41.738,-16.003C61.038,-37.135 88.544,-50.111 116.96,-53.514C145.377,-56.917 174.554,-51.057 200.38,-38.725C227.667,-25.694 252.227,-4.362 262.887,23.936C272.475,49.385 269.978,78.123 261.383,103.925C252.788,129.726 238.481,153.181 224.294,176.382",
    style: {
      fill: "rgb(108,99,255)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24202,0,0,0.24202,4197.55,2125.62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-122.642C86.934,-121.161 168.271,-103.904 247.225,-67.49C257.37,-62.81 254.25,-46.28 252.932,-33.54C251.237,-17.181 250.866,0.254 234.42,0.042C194.823,-0.469 179.077,-12.717 142.357,-27.543C116.403,-38.022 88.411,-46.971 60.091,-45.986C36.837,-45.176 3.316,-31.822 -18.417,-41.394C-35.431,-48.888 -23.118,-70.698 -20.557,-85.784C-17.367,-104.567 -14.884,-122.896 0,-122.642",
    style: {
      fill: "rgb(108,99,255)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24202,0,0,0.24202,4197.55,2125.62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-122.642C86.934,-121.161 168.271,-103.904 247.225,-67.49C257.37,-62.81 254.25,-46.28 252.932,-33.54C251.237,-17.181 250.866,0.254 234.42,0.042C194.823,-0.469 179.077,-12.717 142.357,-27.543C116.403,-38.022 88.411,-46.971 60.091,-45.986C36.837,-45.176 3.316,-31.822 -18.417,-41.394C-35.431,-48.888 -23.118,-70.698 -20.557,-85.784C-17.367,-104.567 -14.884,-122.896 0,-122.642Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4204.37,2114.83C4205.07,2114.41 4205.71,2113.91 4206.28,2113.43C4208.06,2111.95 4209.67,2110.21 4211.75,2109.19C4214.59,2107.81 4217.98,2107.97 4220.98,2108.93C4223.99,2109.9 4226.69,2111.59 4229.39,2113.24C4232.08,2114.89 4234.83,2116.52 4237.88,2117.34C4241.56,2118.34 4245.45,2118.09 4249.25,2118.48C4251.23,2118.68 4253.46,2119.24 4254.41,2120.99C4255.11,2122.26 4254.83,2124.05 4253.68,2124.94C4252.16,2126.12 4249.97,2125.51 4248.16,2124.85C4243.56,2123.16 4238.96,2121.47 4234.36,2119.78C4228.8,2117.73 4223.19,2115.68 4217.34,2114.74C4213.33,2114.09 4208.55,2113.81 4204.37,2114.83C4203.4,2115.44 4202.33,2115.89 4201.25,2115.93C4202.23,2115.46 4203.28,2115.1 4204.37,2114.83Z",
    style: {
      fill: "rgb(40,54,85)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.24202,0,0,0.24202,4229.51,2065.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-32.713C-2.365,-31.121 1.48,-30.807 4.129,-29.752C6.776,-28.696 7.708,-28.748 10.509,-29.279C24.328,-31.899 45.868,-22.435 59.149,-17.801C75.757,-12.006 99.798,7.293 102.443,4.053C105.744,0.012 111.858,-1.665 109.506,-6.322C107.153,-10.98 103.025,-14.471 98.799,-17.531C76.441,-33.72 34.64,-40.006 13.698,-39.203C6.507,-38.928 0,-32.713 0,-32.713",
    style: {
      fill: "rgb(40,54,85)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.270066,0,0,0.270066,3565.28,1325.87)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.619645,0.784882,0.784882,-0.619645,1130.98,2956.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-44.718,-59.711L155.092,-59.711C155.092,-59.711 106.084,-101.806 106.55,-101.216C107.014,-100.628 -76.594,-92.277 -76.594,-92.277L-44.718,-59.711Z",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.799997,-0.600004,-0.600004,-0.799997,1007.64,2944.17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.842,9.059L47.113,9.059L24.724,-20.793L-14.096,-17.525L5.842,9.059Z",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.581242,0.813731,0.813731,-0.581242,740.429,2833.76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.68,-217.719L266.189,-217.719L423.071,172.323L235.966,158.89L88.68,-217.719Z",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.116536,0.993186,0.993186,0.116536,761.227,3087.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-37.126,-151.779L8.276,-151.779L135.321,-35.665L94.311,-32.473L-37.126,-151.779Z",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.973478,-0.228779,-0.228779,-0.973478,731.504,3263.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.423,49.495L400.493,49.495L426.948,89.911L6.549,86.963L-10.423,49.495Z",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1205.73,2995.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,59.723L-6.655,91.309L-25.515,119.306L-149.323,-37.515L-128.691,-54.026L-107.307,-59.583L0,59.723Z",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.594195,0.804321,0.804321,-0.594195,828.372,3048.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-81.689,-20.134L98.464,-20.134L37.606,-165.024L-139.881,-162.182L-81.689,-20.134Z",
    style: {
      fill: "rgb(255,206,199)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.116536,0.993186,0.993186,0.116536,761.227,3087.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-37.126,-151.779L8.276,-151.779L135.321,-35.665L94.311,-32.473L-37.126,-151.779Z",
    style: {
      fill: "rgb(255,186,177)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.971666,-0.236356,-0.236356,-0.971666,719.655,3194.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.43,17.061L159.583,17.061L138.225,-21.107L-14.833,-20.274L2.43,17.061Z",
    style: {
      fill: "rgb(255,156,143)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.957822,0.287363,0.287363,-0.957822,1134.2,3075.35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.593,-4.602L36.495,-4.602L31.356,-44.922L-9.36,-52.828L-6.593,-4.602Z",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,779.05,3117.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-70.941L33.31,-27.824L6.881,-20.937L23.199,0.185L-30.747,14.242L-47.064,-6.881L-73.493,0.004L-106.803,-43.113L-80.375,-49.999L-96.696,-71.127L-42.751,-85.183L-26.429,-64.054L0,-70.941Z",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,942.326,3040.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.563L-79.771,28.132C-87.209,29.77 -95.515,24.8 -98.322,17.033C-101.129,9.264 -97.376,1.639 -89.938,0.001L-10.166,-17.568C-2.729,-19.207 5.576,-14.237 8.384,-6.468C11.191,1.299 7.438,8.924 0,10.563",
    style: {
      fill: "rgb(212,215,221)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,959.014,3004.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.276L-121.938,28.132C-129.375,29.77 -137.681,24.8 -140.488,17.033C-143.296,9.264 -139.542,1.639 -132.104,0.001L-10.166,-26.855C-2.729,-28.494 5.576,-23.524 8.384,-15.755C11.191,-7.988 7.438,-0.363 0,1.276",
    style: {
      fill: "rgb(212,215,221)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-656.769,2770.15)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.7028,0,0,3.7028,-12544.7,-7679.57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3756.78,2193.79C3760.95,2189.16 3766.94,2186.5 3773.02,2185.12C3779.1,2183.74 3785.37,2183.5 3791.57,2182.94C3808.84,2181.36 3825.86,2177.15 3841.88,2170.51C3848.15,2167.91 3854.65,2164.87 3861.4,2165.61C3862.48,2165.72 3863.6,2165.96 3864.43,2166.66C3865.27,2167.35 3862.98,2170.61 3862.54,2169.62L3790.72,2186.74L3757.85,2194.74L3757.04,2194.74L3756.78,2193.79Z",
    style: {
      fill: "rgb(40,54,85)",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3486.91,196.786)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.333701,-0.144291,-0.144291,0.333701,425.108,2015.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-291.745,60.374L12.494,60.374",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8,
      strokeLinejoin: "miter"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.36356,0,0,0.36356,513.752,2027.82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,137.962L214.349,65.514L-75.672,-61.975C-77.701,-62.867 -79.989,-62.969 -82.088,-62.259L-287.138,7.047C-290.745,8.266 -293.174,11.65 -293.174,15.458L-293.174,68.796C-293.174,72.336 -291.07,75.538 -287.82,76.944L-4.31,199.602C-1.535,200.802 1.585,200.931 4.449,199.963L206.348,131.722C211.13,130.106 214.349,125.62 214.349,120.572L214.349,65.514L0,137.962",
    style: {
      fill: "rgb(123,139,154)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8,
      strokeLinejoin: "miter"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.36356,0,0,0.36356,514.244,2005.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,142.141L221.703,67.206L-78.269,-64.657C-80.367,-65.58 -82.734,-65.684 -84.905,-64.95L-296.99,6.734C-300.722,7.995 -303.233,11.495 -303.233,15.434L-303.233,70.601C-303.233,74.263 -301.058,77.576 -297.696,79.03L0,207.825L0,142.141L-288.832,17.251",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8,
      strokeLinejoin: "miter"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.344419,-0.116413,-0.116413,-0.344419,524.55,2092.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16.677,39.197L217.348,39.197L238.38,101.421L4.355,101.422L-16.677,39.197Z",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8,
      strokeLinejoin: "miter"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.36356,0,0,0.36356,423.87,1989.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,31.496C-2.434,30.443 -4.009,28.045 -4.009,25.393L-4.009,10.15C-4.009,6.207 -1.486,2.707 2.254,1.459L106.895,-33.45C108.178,-33.878 109.575,-33.798 110.8,-33.226L187.64,2.652C190.419,3.95 192.195,6.74 192.195,9.808L192.195,23.229C192.195,26.579 190.096,29.569 186.945,30.708L82.988,64.598C80.608,65.374 78.026,65.253 75.729,64.259L0,31.496Z",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8,
      strokeLinejoin: "miter"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.345832,-0.112145,-0.112145,-0.345832,460.506,2008.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.299,14.55C28.49,14.71 92.022,14.482 92.014,14.55",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8,
      strokeLinejoin: "miter"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.33308,0.145719,0.145719,-0.33308,433.947,1993.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.981,-9.47L45.271,-9.47",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8,
      strokeLinejoin: "miter"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.36356,0,0,0.36356,518.096,1997.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,253.327L214.436,180.848C219.693,179.071 223.232,174.139 223.232,168.59L223.232,92.915C223.232,87.78 220.196,83.132 215.495,81.067L31.779,0.392C28.822,-0.905 25.486,-1.052 22.427,-0.016L-192.166,72.627C-197.424,74.407 -200.961,79.342 -200.957,84.893L-200.898,157.546C-200.895,162.618 -197.929,167.22 -193.312,169.317L-9.496,252.848C-6.506,254.208 -3.111,254.379 0,253.327Z",
    style: {
      fill: "rgb(108,99,255)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.344428,0.116384,0.116384,0.344428,527.257,2066.44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-205.865,-33.841L5.563,-33.841",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.333463,-0.14484,-0.14484,0.333463,463.485,2021.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-148.327,30.822L6.405,30.822",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.36356,-0.36356,0,527.706,2074.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-31.274,31.274L31.274,31.274",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: 8
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4442.01,-113.629)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.333631,0,0,-0.333631,0.586914,163.813)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491,245.5C491,109.914 381.086,0 245.5,0C109.914,0 0,109.914 0,245.5C0,381.086 109.914,491 245.5,491C381.086,491 491,381.086 491,245.5Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 491,
    height: 491
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.61967,0,0,-4.61967,-878.603,1559.14)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image3",
    x: 191.468,
    y: 232.772,
    width: "106.285px",
    height: "106.285px",
    transform: "matrix(0.993314,0,0,0.993314,0,0)"
  })))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-208.97,2115.36)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.491,
    cy: 448.779,
    rx: 80.175,
    ry: 80.175,
    style: {
      fill: "rgb(247,247,247)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,1855.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.717,398.609C98.385,398.635 113.713,394.048 126.791,385.421C123.837,369.279 112.592,368.353 112.592,368.353L50.602,368.353C50.602,368.353 40.001,369.222 36.679,384.078C50.157,393.559 66.239,398.635 82.717,398.609Z",
    style: {
      fill: "rgb(128,126,255)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-208.223,2113.82)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.876,
    cy: 450.546,
    rx: 35.543,
    ry: 35.543,
    style: {
      fill: "rgb(66,66,66)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-274.148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.388,386.076L94.188,386.076L94.188,405.915C94.188,412.761 88.638,418.311 81.791,418.311C74.945,418.311 69.395,412.761 69.395,405.915L69.395,386.076L69.388,386.076Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,1829.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.755,386.994L91.82,386.994C93.128,386.994 94.188,388.055 94.188,389.362L94.188,406.833C94.188,413.68 88.638,419.23 81.791,419.23C74.945,419.23 69.395,413.68 69.395,406.833L69.395,389.362C69.395,388.057 70.451,386.998 71.755,386.994Z",
    style: {
      fill: "rgb(203,143,113)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.119124,0.992879,0.992879,-0.119124,-333.928,88.7692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.342,396.618C84.26,404.198 85.333,412.931 83.366,421.234L80.342,421.597L77.388,396.973L80.342,396.618Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-213.23,2118.82)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.876,
    cy: 442.829,
    rx: 35.543,
    ry: 35.543,
    style: {
      fill: "rgb(203,143,113)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,1753.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.341,466.399C60.758,464.865 61.281,463.176 62.659,462.378C63.748,461.741 65.098,461.84 66.356,461.904C76.18,462.441 85.919,460.201 95.474,457.861C100.938,456.526 106.783,454.9 110.316,450.497C113.85,446.094 109.242,432.256 103.864,430.623C100.33,429.541 96.231,431.556 92.881,429.973C91.389,429.266 90.294,427.944 89.007,426.912C86.371,424.792 82.986,423.937 79.707,423.131C75.876,422.184 71.734,421.258 68.094,422.778C65.267,423.951 63.204,426.432 60.525,427.902C55.429,430.729 49.217,429.414 43.379,429.4C41.407,429.4 39.054,429.796 38.269,431.605C37.739,432.835 38.163,434.234 38.22,435.57C38.389,439.811 34.891,443.111 31.958,446.172C29.025,449.232 26.254,453.6 28.106,457.402C28.813,458.851 30.106,459.946 30.841,461.381C32.106,463.869 31.47,466.873 31.93,469.622C32.389,471.708 33.169,473.711 34.241,475.559C36.417,479.799 47.351,502.628 52.376,496.825C54.807,493.998 55.203,485.828 56.186,482.153C57.543,476.871 58.928,471.62 60.341,466.399Z",
    style: {
      fill: "rgb(66,66,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-228.798,2101.58)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.588,
    cy: 444.122,
    rx: 6.198,
    ry: 3.308,
    style: {
      fill: "rgb(203,143,113)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4456.58,-113.629)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.333631,0,0,-0.333631,195.163,163.813)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491,245.5C491,109.914 381.086,0 245.5,0C109.914,0 0,109.914 0,245.5C0,381.086 109.914,491 245.5,491C381.086,491 491,381.086 491,245.5Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 491,
    height: 491
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.61967,0,0,-4.61967,-1529.11,1559.14)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image6",
    x: 333.228,
    y: 232.772,
    width: "106.285px",
    height: "106.285px",
    transform: "matrix(0.993314,0,0,0.993314,0,0)"
  })))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-82.575,2241.66)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 277.222,
    cy: 448.857,
    rx: 80.175,
    ry: 80.175,
    style: {
      fill: "rgb(247,247,247)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,1855.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.293,398.594C292.95,398.614 308.268,394.028 321.338,385.406C318.384,369.263 307.139,368.338 307.139,368.338L245.17,368.338C245.17,368.338 234.569,369.207 231.247,384.063C244.727,393.545 260.812,398.621 277.293,398.594Z",
    style: {
      fill: "rgb(128,126,255)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-81.9834,2240.05)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 276.444,
    cy: 450.547,
    r: 38.702,
    style: {
      fill: "rgb(249,118,85)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-274.148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.956,386.076L288.756,386.076L288.756,405.915C288.756,412.761 283.206,418.311 276.36,418.311C269.513,418.311 263.963,412.761 263.963,405.915L263.963,386.076L263.956,386.076Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,1829.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.324,386.994L286.389,386.994C287.696,386.994 288.756,388.055 288.756,389.362L288.756,406.833C288.756,413.68 283.206,419.23 276.36,419.23C269.513,419.23 263.963,413.68 263.963,406.833L263.963,389.362C263.963,388.055 265.023,386.994 266.331,386.994L266.324,386.994Z",
    style: {
      fill: "rgb(255,181,143)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.119124,0.992879,0.992879,-0.119124,-162.537,-104.414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.91,396.618C278.828,404.198 279.901,412.931 277.935,421.234L274.91,421.597L271.956,396.973L274.91,396.618Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-86.9909,2245.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 276.444,
    cy: 442.829,
    r: 35.543,
    style: {
      fill: "rgb(255,181,143)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-56.4738,2214.48)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.395,
    cy: 489.913,
    rx: 14.305,
    ry: 14.305,
    style: {
      fill: "rgb(249,118,85)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-47.3348,2205.34)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 276.395,
    cy: 503.999,
    r: 9.393,
    style: {
      fill: "rgb(249,118,85)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,1718.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.19,495.899C263.218,492.772 259.935,484.718 262.733,477.608C262.634,477.806 262.535,478.011 262.444,478.216C259.21,485.425 262.432,493.891 269.642,497.125C276.851,500.359 285.317,497.136 288.551,489.927C288.643,489.722 288.728,489.517 288.813,489.305C285.363,496.125 277.162,499.029 270.19,495.899Z",
    style: {
      fill: "rgb(249,118,85)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0570033,0.998374,0.998374,-0.0570033,-199.878,-187.036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.434,436.478C267.434,436.478 298.629,449.698 283.398,492.907L267.434,483.965L260.188,466.914L267.434,436.478Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0369847,0.647762,0.647762,-0.0369847,-683.644,1887.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.434,436.931C267.434,436.931 298.629,450.15 283.398,493.36L267.434,484.417L260.188,467.367L267.434,436.931Z",
    style: {
      fill: "rgb(249,118,85)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,1722.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.677,485.5C271.893,484.775 281.152,484.775 290.368,485.5C299.584,486.225 269.914,487.401 262.677,485.5Z",
    style: {
      fill: "rgb(66,66,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,1698.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.544,495.172C277.833,495.146 277.122,495.2 276.423,495.334L276.967,495.334C281.758,495.487 285.663,499.225 286.026,504.004C286.389,508.783 283.093,513.068 278.381,513.943C283.565,513.99 287.805,509.826 287.852,504.642C287.898,499.459 283.734,495.219 278.551,495.172L278.544,495.172Z",
    style: {
      fill: "rgb(249,118,85)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-110.033,2221.97)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.894,
    cy: 442.864,
    rx: 6.198,
    ry: 3.308,
    style: {
      fill: "rgb(255,181,143)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-63.9071,2268.1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.987,
    cy: 442.864,
    rx: 6.198,
    ry: 3.308,
    style: {
      fill: "rgb(255,181,143)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.576629,-0.297426,-0.297426,-0.576629,-394.421,2394.09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.705,476.576L257.506,476.576L256.266,470.766L251.166,470.144L249.705,476.576Z",
    style: {
      fill: "rgb(249,118,85)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4331.15,-215.208)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.333631,0,0,-0.333631,388.477,530.239)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491,245.5C491,109.914 381.086,0 245.5,0C109.914,0 0,109.914 0,245.5C0,381.086 109.914,491 245.5,491C381.086,491 491,381.086 491,245.5Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 491,
    height: 491
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.61967,0,0,-4.61967,-1529.11,2188.18)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image9",
    x: 333.228,
    y: 369.853,
    width: "106.285px",
    height: "106.285px",
    transform: "matrix(0.993314,0,0,0.993314,0,0)"
  })))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-194.889,2604.82)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 470.533,
    cy: 82.441,
    rx: 80.175,
    ry: 80.175,
    style: {
      fill: "rgb(247,247,247)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2330.88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.604,32.179C486.271,32.204 501.599,27.618 514.677,18.99C511.716,2.841 500.478,1.915 500.478,1.915L438.488,1.915C438.488,1.915 427.887,2.784 424.565,17.64C438.042,27.123 454.125,32.202 470.604,32.179Z",
    style: {
      fill: "rgb(128,126,255)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-194.293,2603.22)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.763,
    cy: 84.13,
    rx: 38.702,
    ry: 38.702,
    style: {
      fill: "rgb(134,70,37)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,458.706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.267,19.638L482.067,19.638L482.067,39.477C482.073,42.768 480.769,45.927 478.444,48.256C476.119,50.586 472.962,51.895 469.671,51.895C462.824,51.895 457.274,46.344 457.274,39.498L457.274,19.638L457.267,19.638Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2305.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.614,20.578L479.678,20.578C480.986,20.578 482.046,21.638 482.046,22.946L482.046,40.417C482.046,47.263 476.496,52.813 469.65,52.813C462.803,52.813 457.253,47.263 457.253,40.417L457.253,22.946C457.253,21.638 458.313,20.578 459.621,20.578L459.614,20.578Z",
    style: {
      fill: "rgb(255,181,143)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.119122,0.99288,0.99288,-0.119122,371.535,26.4401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.2,30.202C472.118,37.782 473.191,46.514 471.224,54.817L468.2,55.18L465.246,30.556L468.2,30.202Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-199.3,2608.23)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.763,
    cy: 76.412,
    rx: 35.543,
    ry: 35.543,
    style: {
      fill: "rgb(255,181,143)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0570033,0.998374,0.998374,-0.0570033,348.235,-34.5028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.745,70.062C460.745,70.062 491.94,83.281 476.709,126.491L460.745,117.548L453.499,100.498L460.745,70.062Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0369847,0.647762,0.647762,-0.0369847,-328.015,1986.33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.745,70.507C460.745,70.507 491.94,83.727 476.709,126.936L460.745,117.994L453.499,100.943L460.745,70.507Z",
    style: {
      fill: "rgb(134,70,37)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2205.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.312,116.521C445.322,113.395 447.067,110.556 449.401,108.245C456.391,101.332 467.854,99.877 473.735,91.989C474.381,93.118 474.519,94.468 474.115,95.704C473.711,96.94 472.802,97.948 471.614,98.477C477.268,98.442 483.778,97.947 486.958,93.311C488.565,97.05 487.874,101.381 485.184,104.435C490.174,104.661 495.503,108.047 495.828,113.036C496.04,116.358 493.962,119.503 491.227,121.412C488.492,123.32 485.198,124.175 481.947,124.882C472.462,127.002 438.121,135.773 444.312,116.521Z",
    style: {
      fill: "rgb(134,70,37)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2277.44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.306,40.385L504.366,40.385L486.032,56.718C468.363,48.449 455.401,56.718 455.401,56.718L436.177,41.07L434.241,41.311C434.786,60.721 450.809,76.101 470.226,75.852C489.642,75.603 505.265,59.817 505.313,40.399L505.306,40.385ZM469.713,62.966C462.801,62.966 457.196,61.552 457.196,59.835C457.196,58.117 462.801,56.704 469.713,56.704C476.625,56.704 482.23,58.117 482.23,59.835C482.23,61.552 476.625,62.966 469.706,62.966L469.713,62.966Z",
    style: {
      fill: "rgb(134,70,37)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-222.347,2585.13)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 434.205,
    cy: 76.447,
    rx: 6.198,
    ry: 3.308,
    style: {
      fill: "rgb(255,181,143)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-176.221,2631.26)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 505.299,
    cy: 76.447,
    rx: 6.198,
    ry: 3.308,
    style: {
      fill: "rgb(255,181,143)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4190.34,-95.5378)"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.333631,0,0,-0.333631,388.477,345.795)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491,245.5C491,109.914 381.086,0 245.5,0C109.914,0 0,109.914 0,245.5C0,381.086 109.914,491 245.5,491C381.086,491 491,381.086 491,245.5Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip10)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 491,
    height: 491
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.61967,0,0,-4.61967,-878.603,2188.18)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image6",
    x: 191.468,
    y: 369.853,
    width: "106.285px",
    height: "106.285px",
    transform: "matrix(0.993314,0,0,0.993314,0,0)"
  })))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-75.3738,2485.11)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 470.383,
    cy: 266.796,
    rx: 80.175,
    ry: 80.175,
    style: {
      fill: "rgb(247,247,247)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2091.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.609,216.61C486.276,216.636 501.604,212.049 514.682,203.422C511.728,187.28 500.483,186.354 500.483,186.354L438.486,186.354C438.486,186.354 427.885,187.223 424.563,202.079C438.043,211.561 454.128,216.637 470.609,216.61Z",
    style: {
      fill: "rgb(128,126,255)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,89.8233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.272,204.088L482.072,204.088L482.072,223.927C482.072,230.773 476.522,236.323 469.676,236.323C462.827,236.327 457.272,230.776 457.272,223.927L457.272,204.088Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2066.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.64,205.007L479.705,205.007C481.012,205.007 482.072,206.067 482.072,207.374L482.072,224.846C482.072,231.692 476.522,237.242 469.676,237.242C462.827,237.246 457.272,231.695 457.272,224.846L457.272,207.374C457.272,206.067 458.332,205.007 459.64,205.007Z",
    style: {
      fill: "rgb(255,196,167)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.119125,0.992879,0.992879,-0.119125,188.438,-136.048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.226,214.635C472.144,222.214 473.217,230.947 471.251,239.25L468.226,239.613L465.272,214.989L468.226,214.635Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-79.6383,2488.56)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.761,
    cy: 260.845,
    rx: 35.543,
    ry: 35.543,
    style: {
      fill: "rgb(255,196,167)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-101.236,2464.99)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 434.953,
    cy: 262.364,
    rx: 6.198,
    ry: 3.308,
    style: {
      fill: "rgb(255,196,167)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-56.1877,2510.04)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 504.385,
    cy: 262.364,
    rx: 6.198,
    ry: 3.308,
    style: {
      fill: "rgb(255,196,167)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,-0.648817,-7693.44,9783.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11456,11712.5L11465,11712.5C11466.7,11712.5 11468.1,11711.2 11468.1,11709.5L11468.1,11708C11468.1,11706.3 11466.7,11704.9 11465,11704.9L11456,11704.9C11454.3,11704.9 11452.9,11706.3 11452.9,11708L11452.9,11709.5C11452.9,11711.2 11454.3,11712.5 11456,11712.5Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(66,66,66)",
      strokeWidth: "3.08px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,-0.648817,-7693.44,9783.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11493.1,11704.9L11484.1,11704.9C11482.4,11704.9 11481,11706.3 11481,11708L11481,11709.5C11481,11711.2 11482.4,11712.5 11484.1,11712.5L11493.1,11712.5C11494.8,11712.5 11496.2,11711.2 11496.2,11709.5L11496.2,11708C11496.2,11706.3 11494.8,11704.9 11493.1,11704.9Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(66,66,66)",
      strokeWidth: "3.08px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,-0.648817,-7693.44,9777.83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11467.5,11703.1C11467.5,11703.1 11472.4,11705.7 11481.3,11703.1",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(66,66,66)",
      strokeWidth: "3.08px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,1994.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.335,266.343L503.056,286.606C503.056,286.606 513.721,273.164 494.335,266.343Z",
    style: {
      fill: "rgb(151,151,151)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.483885,-0.432226,0.432226,0.483885,-10854.6,1491.82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11494,11702.9L11511.5,11702.9",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(66,66,66)",
      strokeWidth: "3.08px",
      strokeMiterlimit: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,1994.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.201,266.343L436.479,286.606C436.479,286.606 425.814,273.164 445.201,266.343Z",
    style: {
      fill: "rgb(151,151,151)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.486658,-0.4291,0.4291,-0.486658,281.821,12789.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11437.5,11702.9L11455.1,11702.9",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(66,66,66)",
      strokeWidth: "3.08px",
      strokeMiterlimit: 4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.676878,0,0,0.676878,4427.84,632.308)"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.333631,0,0,-0.333631,195.163,530.239)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491,245.5C491,109.914 381.086,0 245.5,0C109.914,0 0,109.914 0,245.5C0,381.086 109.914,491 245.5,491C381.086,491 491,381.086 491,245.5Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip12)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 491,
    height: 491
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.82497,0,0,-6.82497,-3004.68,3827.91)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image14",
    x: 440.605,
    y: 489.323,
    width: "71.942px",
    height: "71.942px",
    transform: "matrix(0.99919,0,0,0.999191,0,0)"
  })))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-320.312,2479.41)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 277.232,
    cy: 82.43,
    rx: 80.175,
    ry: 80.175,
    style: {
      fill: "rgb(247,247,247)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-323.293,2481.17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.044,33.727C245.371,33.727 232.247,52.888 232.247,77.773C232.247,102.658 245.371,123.825 272.044,123.825C298.717,123.825 320.337,103.654 320.337,78.776C320.337,53.898 298.739,33.727 272.044,33.727Z",
    style: {
      fill: "rgb(66,66,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2330.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.296,32.166C292.965,32.194 308.296,27.607 321.376,18.978C318.422,2.836 307.177,1.91 307.177,1.91L245.18,1.91C245.18,1.91 234.579,2.779 231.257,17.635C244.735,27.116 260.817,32.192 277.296,32.166Z",
    style: {
      fill: "rgb(128,126,255)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,458.692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.945,19.641L288.766,19.641L288.766,39.48C288.772,42.776 287.465,45.939 285.133,48.269C282.801,50.6 279.638,51.905 276.342,51.898C269.495,51.898 263.945,46.348 263.945,39.501L263.945,19.641Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2305.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.327,20.569L286.392,20.569C287.699,20.569 288.759,21.629 288.759,22.937L288.759,40.408C288.759,43.699 287.45,46.855 285.121,49.181C282.791,51.506 279.633,52.81 276.341,52.804C269.495,52.804 263.945,47.254 263.945,40.408L263.945,22.929C263.945,21.622 265.005,20.562 266.313,20.562L266.327,20.569Z",
    style: {
      fill: "rgb(255,181,143)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.119122,0.99288,0.99288,-0.119122,201.29,218.353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.92,30.191C278.838,37.771 279.911,46.504 277.945,54.807L274.92,55.169L271.966,30.546L274.92,30.191Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-324.724,2482.81)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.454,
    cy: 76.409,
    rx: 35.543,
    ry: 35.543,
    style: {
      fill: "rgb(255,181,143)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2008.99)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,339.822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.491,116.333C235.491,116.333 257.626,113.648 274.363,92.191C274.363,92.191 296.498,116.56 311.92,113.874C311.92,113.874 320.86,104.481 311.92,95.095C302.979,85.709 296.046,73.857 284.201,75.419C272.355,76.981 257.817,77.652 251.562,83.243C245.308,88.833 235.491,116.333 235.491,116.333Z",
    style: {
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648817,0,0,0.648817,-553.667,2228.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.491,116.779C235.491,116.779 257.626,114.093 274.363,92.636C274.363,92.636 296.498,117.005 311.92,114.319C311.92,114.319 320.86,104.926 311.92,95.541C302.979,86.155 296.046,74.302 284.201,75.864C272.355,77.426 257.846,78.069 251.591,83.724C245.336,89.378 235.491,116.779 235.491,116.779Z",
    style: {
      fill: "rgb(66,66,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-347.776,2459.72)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.897,
    cy: 76.437,
    rx: 6.198,
    ry: 3.308,
    style: {
      fill: "rgb(255,181,143)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.648817,-0.648817,0,-301.649,2505.85)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.99,
    cy: 76.437,
    rx: 6.198,
    ry: 3.308,
    style: {
      fill: "rgb(255,181,143)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.344257,0,0,0.344257,3853.43,1712.48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-292.671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640.702,308.621C640.702,308.621 643.301,343.712 643.301,345.012C643.301,346.311 625.106,435.988 625.106,435.988C625.106,435.988 599.112,485.376 625.106,484.076C651.099,482.776 643.301,437.288 643.301,437.288L670.594,361.907L658.897,308.621L640.702,308.621Z",
    style: {
      fill: "rgb(160,97,106)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,73.0348)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.169,
    y: 32.746,
    width: 516.463,
    height: 362.798,
    style: {
      fill: "rgb(212,215,221)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,213.459)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.645,
    y: 30.746,
    width: 129.678,
    height: 226.374,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,46.8091)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.632,
    y: 210.976,
    width: 34.932,
    height: 32.563,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,46.8091)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250.404,
    y: 210.976,
    width: 34.932,
    height: 32.563,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,136.803)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.632,
    y: 165.388,
    width: 34.932,
    height: 33.748,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,136.803)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250.404,
    y: 165.388,
    width: 34.932,
    height: 33.748,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,421.525,665.464)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 292.832,
    cy: 128.693,
    r: 8.245,
    style: {
      fill: "rgb(108,99,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,159.237)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.799,
    y: 63.479,
    width: 256.357,
    height: 215.13,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-327.242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.602,501.325L82.199,501.325L123.831,414.283L133.148,394.794L145.337,369.308L154.654,349.819L165.455,327.242L657.407,327.242L663.786,349.819L669.295,369.308L676.499,394.794L682.008,414.283L706.602,501.325Z",
    style: {
      fill: "rgb(63,61,86)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,177.977)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.794,
    y: 133.94,
    width: 8.995,
    height: 55.469,
    style: {
      fill: "rgb(108,99,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,145.744)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.794,
    y: 174.417,
    width: 8.995,
    height: 6.746,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,210.209)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.794,
    y: 142.185,
    width: 8.995,
    height: 6.746,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,177.977)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.286,
    y: 133.94,
    width: 21.738,
    height: 55.469,
    style: {
      fill: "rgb(108,99,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,145.744)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.286,
    y: 174.417,
    width: 21.738,
    height: 6.746,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,210.209)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.286,
    y: 142.185,
    width: 21.738,
    height: 6.746,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,177.977)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.271,
    y: 133.94,
    width: 8.995,
    height: 55.469,
    style: {
      fill: "rgb(108,99,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,145.744)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.271,
    y: 174.417,
    width: 8.995,
    height: 6.746,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,210.209)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.271,
    y: 142.185,
    width: 8.995,
    height: 6.746,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,177.977)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.764,
    y: 133.94,
    width: 8.995,
    height: 55.469,
    style: {
      fill: "rgb(108,99,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,145.744)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.764,
    y: 174.417,
    width: 8.995,
    height: 6.746,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,210.209)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.764,
    y: 142.185,
    width: 8.995,
    height: 6.746,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.935726,-0.352727,-0.352727,-0.935726,85.2433,645.781)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 434.503,
    y: 133.94,
    width: 8.995,
    height: 55.469,
    style: {
      fill: "rgb(108,99,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.935728,-0.352721,-0.352721,-0.935728,90.1951,642.805)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.819,
    y: 173.382,
    width: 8.995,
    height: 6.746,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.935726,-0.352727,-0.352727,-0.935726,80.2895,648.756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.188,
    y: 143.221,
    width: 8.995,
    height: 6.746,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,177.977)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.173,
    y: 133.94,
    width: 21.738,
    height: 55.469,
    style: {
      fill: "rgb(108,99,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,145.744)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.173,
    y: 174.417,
    width: 21.738,
    height: 6.746,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,210.209)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.173,
    y: 142.185,
    width: 21.738,
    height: 6.746,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,177.977)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564.931,
    y: 133.94,
    width: 8.995,
    height: 55.469,
    style: {
      fill: "rgb(108,99,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,145.744)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564.931,
    y: 174.417,
    width: 8.995,
    height: 6.746,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,210.209)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564.931,
    y: 142.185,
    width: 8.995,
    height: 6.746,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,177.977)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.438,
    y: 133.94,
    width: 8.995,
    height: 55.469,
    style: {
      fill: "rgb(108,99,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,145.744)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.438,
    y: 174.417,
    width: 8.995,
    height: 6.746,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,210.209)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.438,
    y: 142.185,
    width: 8.995,
    height: 6.746,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.352726,-0.935727,-0.935727,-0.352726,498.996,899.346)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.462,
    y: 157.177,
    width: 55.469,
    height: 8.995,
    style: {
      fill: "rgb(108,99,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.352726,-0.935727,-0.935727,-0.352726,516.786,894.904)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.508,
    y: 172.257,
    width: 6.746,
    height: 8.995,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.352718,-0.93573,-0.93573,-0.352718,481.21,903.789)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 528.139,
    y: 142.097,
    width: 6.746,
    height: 8.995,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,238.693)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.799,
    y: 128.693,
    width: 256.357,
    height: 5.247,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,177.977)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.487,
    y: 133.94,
    width: 47.224,
    height: 55.469,
    style: {
      fill: "rgb(108,99,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,156.988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 476.105,
    y: 166.922,
    width: 23.987,
    height: 10.494,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-7.92022)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.729,
    y: 230.636,
    width: 4.498,
    height: 47.973,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,711.613,751.667)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 480.977,
    cy: 230.636,
    rx: 7.496,
    ry: 7.496,
    style: {
      fill: "rgb(242,242,242)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,814.632,-436.682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.337,478.748L669.295,478.748L659.978,459.259L150.846,459.259L145.337,478.748Z",
    style: {
      fill: "rgb(108,99,255)",
      fillRule: "nonzero"
    }
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image3",
    width: "107px",
    height: "107px",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image6",
    width: "107px",
    height: "107px",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image9",
    width: "107px",
    height: "107px",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image14",
    width: "72px",
    height: "72px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAIe0lEQVR4nO1c23LcuBE9AMGR5LL9lNRmN3v5E5e/a2wPySlJ/2X/SS6bZCt5clJ2aUgQ+2AeuNkDkJzRzMZr6byIBBunm80mGg1wZPAbYr1ePz0Fz+3t7f9OwbME5twK1uv106IoAADOOdzd3aEoCnjvsVqt4L2H9x7GGFhrURQF+r5HCAHeezjn4jEASK7dboebm5uzOussDrq+vn4KAB8+fEBRFLi4uIjX2rY1ZVkGnn/8+BEhBDx58iTK9H0Pa208997j7u4OFxcX0UFDuymKInK9fv365M46qYPqun4GACGEUbsxZtRmzCe1U23HygBA0zT/ve+9RJ2nIKmq6tkpeE6NUzjq3g76Up1D3NdJRzvoS3eMxrGOOspBvzfnEMc4yc6LjKGdowfI++DcXMc82GJe5DM2m82zrutgjIkZxBiDtm1japbnKiXDe48QAqy16PseXdeNZFJ927aNfQjKAIC1Fl3XwXs/4gohoOu6yMXzly9fXrx792639J4Xv2Lr9fp3+VrlcHt7u+h1W+Sgr805xBInzTroa3UOMeekSQd97c4hppyUzWLr9fqZMQZlWeLy8hLAp0F0tVoBAMqyjLJlWaIsyzhIXl1dwRiDoihiW1EUKMsSV1dXsY9zLsklazcel2UZB2rqY7+rq6uYINhmrR3ps9ZmbWeJlILLXSAxsxXPpQPKshzVRTK1Xl5eZmsnyVWW5YjrEH0AopPpSGNMbFvCRZkcklfrun4+VxCmbj4195DtU1y6KD23vhRX0zTv9/h0Q1VVz/e0PiBoJx08k35oGEXQQ48eQkbRYwTNIEbQY/SMwSgapXkWnF3X7XXgvIZFoVxIl+AiO/ukuIqigDEmcrGITXHJ9ekUF1P6lO3W2niNnCx2U7bL1B8dROJUR+BzdZwzVPNMQTp2CVfOJt0/JycdcqjtBgBevXr1+HolcHNz8/5xkJ7Bo4NmYN68efO8KAq0bRsHPK70ceWv73s459C2bdz9bNsWAGJNw8GNg3dZlvDeo+/7WBz2fR+vtW0bdUjeEEJcBeTqpdZHLq40cvCl7c45GGP2bJf6pO0c4MnpnIu2O1a4rIZ3u92oKpbLmDzmVjELxL2RfzCQWYo3zope6mvbdrRKIMF+AKJN1trIJeWk7cxGS22nc+W90HbXdd1oNj2VUrXxczJLuBghS/Tl0vMh+si11PbHMWgGjw6awaODZhAdxH0rOctNTf+1DLA/g6WMbNcyzGiaS+tMyaTOtT7Nw+y61Hb2d3rpkiUFU6IG5WSqlNlCynjvY9rVMvKcmYzZb06fzDpSRm5Gatv5gdZS27uu+5ThQgiGjtFCqQiKnhUyOs1ThkUijU/JnFLfKbnil2y5qlyDk7sprFYr7HbTu7rctp5K18CnRfi7u7tJGefcouJ4iVxOnzPGGB2yclGbs2M9odIyAOKsdUpGRteUHL9PnONK2Z7SN8eV0+f4JOkEIjX+0AlaRoeplGHEpEL5WH36G0YdjZxt6/HsUNsBwFlr41XnXLTYe28AoCiK4L03vJmyLIMk7LrOOOfC8KqyD+THlV3XGWttGOqmpL5hlmycc4HHgwystSOu1WoVeMybPdR22jtne4ypvu+x2+2i8XwKHMSJtm1HMgCw2+2M/iqVCik3OCnKhBD29JFfPQBgWLdiNGp9S2wPISRt1/q07Y4hJr/5IaE85jX9KoQQjHzC8kZk/1RIJ7j2XscEV9R3iO1ahlzGmEnbHd2X+1RXH2sZdoeCrMJTXCl98toU13Bjk3adwnYAcEtS/EOGK4rC5LIMsJ82NVLXUlyp1LqE61h9p7LdAMBms/nDuVLloWl+Cddvleavr6//44C4/zQabJlmrbVBXtOETJXymv4NBc/lNa1vWPqMaTcXcd77mObJofWlbE9NKmWaF5PdkV2OgkN1nU2VvJZ6Cl3XGf0UaCTlZJrn3ETry3ERjKC2bUdcKX3a9lzEpvRJu+TW8x+ld5e+xzLcc3IsVFOvh9TH6cB99R1qu5Qnmqb5NzDeeh6x5FKlRqqmmpLJlRRTaf5QfYfaPiUTHfSY7tMYua6u62/keWpmq3Foaj5Hmj+1vrquf+HxaFjnmomumeRf+RMAQi+GUUa+NlKG401q6UMvdKX0ee+TaX5K36G2E3vu22633wyCyTSvIVNs7ol47421dpTmtQzTfFEUYeqpy/65AV/antMnueQgvdlsfpEye58ByxQ6lealYbnULJ+o997I41wE5bjUj1lkmk/qO9Z2jeSVzWbzp2yPrxjb7fZfui3ruqqqvj2vOV8Wmqb5Z6o9+6X93KL6Q8Fkvmya5kFEUVVVyegBFvwcqqqq73g8lZrnBumpan4Jl07NuWo+V4bk9DVN84+p+591EABUVfVn3ca0L6cAsmAEAGNMGOovI49TXMw68jjHldNHrkEfjDFhSl9d15POAQ74SSadlFrazC1YSbklMimcSp+W2263PycVKiz+uqNpmp/l4rtWKMsSeTP6mpRJvVpTlfix+tjG7eSlzgGO+N18VVXfH9rnS0LTNH8/RP6gn4UDwNu3b9+/ePFi9HsyOZDKOksvUmkZ9pURJdeOtIw811zAeCBmf7kbu91uD3IOcI9/TVHX9feDUcYMe0tyYDViv2mQGQ7TMgDM4IDA40EGADTXrD628bhpmr8dc59HO4ioquqHXGomUquEuSXQKa7cquSUvmMdE3XepzNR1/UPwOewDmrHUj/14cmOlju1nByAJTQ325i6pUxd1/dyDnAiBxFVVf0I/P/T/Ha7/esx9qdwUgcRm83mR3kuo0X+jzIOyoQcpK218aNv7SSe86dUbG+a5mSOifpOTahRVdVP5+RvmuYv5+Q/u4MkNpvNT/I3ETKC9E6ETOc6grbb7VmdIvErZtM3zhVAtHAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackLoopDonate);
export default __webpack_public_path__ + "static/media/feedback_loop_donate.fdc873c8.svg";
export { ForwardRef as ReactComponent };